import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import translation files
import translation from './locales/translation.json';

// The translations
const resources = translation;

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en', // Use 'en' if current language translation is not available
    interpolation: {
      escapeValue: false // React already safe from XSS
    }
  });

export default i18n;